// Age ranges accepted by the studentless correction backend (legacy form-test schemas).

export const FONO_AGE_OPTIONS = [
  { value: "3", label: "3.0 - 3.11 años" },
  { value: "4", label: "4.0 - 4.11 años" },
  { value: "5", label: "5.0 - 5.11 años" },
  { value: "6", label: "6.0 - 6.11 años" },
];

export const FONO_EXTENDED_AGE_OPTIONS = [
  ...FONO_AGE_OPTIONS,
  { value: "7", label: "7.0 - 7.11 años" },
  { value: "8", label: "8.0 - 8.11 años" },
  { value: "9", label: "9.0 - 9.11 años" },
];

/** IDTEL Rango_Etario only supports 6–9 años. */
export const IDTEL_AGE_OPTIONS = [
  { value: "6", label: "6.0 - 6.11 años" },
  { value: "7", label: "7.0 - 7.11 años" },
  { value: "8", label: "8.0 - 8.11 años" },
  { value: "9", label: "9.0 - 9.11 años" },
];

/** WISC-V — mismos tramos que Wisc5.vue (var edad). */
export const WISC5_AGE_OPTIONS = [
  { value: "6.1", label: "6 años a 6 años 5 meses" },
  { value: "6.2", label: "6 años 5 meses a 7 años" },
  { value: "7.1", label: "7 años a 7 años 5 meses" },
  { value: "7.2", label: "7 años 5 meses a 8 años" },
  { value: "8.1", label: "8 años a 8 años 5 meses" },
  { value: "8.2", label: "8 años 5 meses a 9 años" },
  { value: "9.1", label: "9 años a 9 años 5 meses" },
  { value: "9.2", label: "9 años 5 meses a 10 años" },
  { value: "10.1", label: "10 años a 10 años 5 meses" },
  { value: "10.2", label: "10 años 5 meses a 11 años" },
  { value: "11.1", label: "11 años a 11 años 5 meses" },
  { value: "11.2", label: "11 años 5 meses a 12 años" },
  { value: "12.1", label: "12 años a 12 años 5 meses" },
  { value: "12.2", label: "12 años 5 meses a 13 años" },
  { value: "13.1", label: "13 años a 13 años 5 meses" },
  { value: "13.2", label: "13 años 5 meses a 14 años" },
  { value: "14.1", label: "14 años a 14 años 5 meses" },
  { value: "14.2", label: "14 años 5 meses a 15 años" },
  { value: "15.1", label: "15 años a 15 años 5 meses" },
  { value: "15.2", label: "15 años 5 meses a 16 años" },
  { value: "16.1", label: "16 años a 16 años 5 meses" },
  { value: "16.2", label: "16 años 5 meses a 17 años" },
];

/** WAIS-IV — mismos tramos que Wais4.vue (var edad). */
export const WAIS4_AGE_OPTIONS = [
  { value: "16 a 17", label: "16 a 17 años" },
  { value: "18 a 19", label: "18 a 19 años" },
  { value: "20 a 24", label: "20 a 24 años" },
  { value: "25 a 29", label: "25 a 29 años" },
  { value: "30 a 34", label: "30 a 34 años" },
  { value: "35 a 44", label: "35 a 44 años" },
  { value: "45 a 54", label: "45 a 54 años" },
  { value: "55 a 64", label: "55 a 64 años" },
  { value: "65 a 69", label: "65 a 69 años" },
  { value: "70 a 74", label: "70 a 74 años" },
  { value: "75 a 79", label: "75 a 79 años" },
  { value: "80 a 84", label: "80 a 84 años" },
  { value: "85 a 89", label: "85 a 89 años" },
];

/** Perfil Sensorial adolescentes y adultos: los grupos de edad de sus normas. */
export const SENSORIAL_ADULTOS_AGE_OPTIONS = [
  { value: "11-17", label: "11-17 años" },
  { value: "18-64", label: "18-64 años" },
  { value: "65+", label: "65 años o más" },
];

function anios(desde, hasta) {
  const out = [];
  for (let edad = desde; edad <= hasta; edad += 1) {
    out.push({ value: String(edad), label: `${edad} años` });
  }
  return out;
}

/**
 * SPM-2: edades de cada formulario. Viven acá y no en spm2Data.js para que el
 * catálogo (que carga todo el sitio) no arrastre los 320 ítems del SPM-2.
 */
export const SPM2_AGE_OPTIONS = {
  preescolar_hogar: anios(2, 5),
  nino_hogar: anios(5, 12),
  adolescente_hogar: anios(12, 21),
  adolescente_autorreporte: anios(12, 21),
};

export function ageLabelForValue(value, options = FONO_AGE_OPTIONS) {
  const match = options.find((opt) => opt.value === String(value));
  return match ? match.label : "";
}
